import { createAsyncThunk } from '@reduxjs/toolkit';
import { Hexabase } from 'hexabase-sdk';
import { Condition } from 'hexabase-sdk/dist/models';
import { MedicalSearchRequest } from '../../types';

export const getListMedical = createAsyncThunk<any, { pageNumber: number; searchValue?: MedicalSearchRequest }>(
  'cpapInstructions/getItems',
  async (params) => {
    try {
      const conditions: Condition[] = [];
      params.searchValue?.facility_name &&
        conditions.push({
          search_value: [params.searchValue.facility_name],
          data_type: 'text',
          id: 'facility_name',
          exact_match: false,
          include_null: false,
        });
      params.searchValue?.address &&
        conditions.push({
          search_value: [params.searchValue.address],
          data_type: 'text',
          id: 'facility_address1',
          exact_match: false,
          include_null: false,
        });
      params.searchValue?.phone &&
        conditions.push({
          search_value: [params.searchValue.phone],
          data_type: 'text',
          id: 'facility_tel',
          exact_match: false,
          include_null: false,
        });
      params.searchValue?.code &&
        conditions.push({
          search_value: [params.searchValue.code],
          data_type: 'text',
          id: 'facility_code',
          exact_match: false,
          include_null: false,
        });

      const MedicalItems = await Hexabase.items().getItemsAsync({
        project_id: 'CPAP',
        datastore_id: 't_medical_institution',
        per_page: 20,
        page: params.pageNumber,
        use_display_id: true,
        sort_field_id: 'created_at',
        sort_order: 'desc',
        conditions: params.searchValue ? conditions : undefined,
      });
      return MedicalItems;
    } catch (e) {
      console.log(e);
    }
  },
);
